import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  if (!amount && amount !== 0) return '---';
  const num = Number(amount);
  if (isNaN(num)) return '---';
  if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `${(num / 100000).toFixed(2)} Lac`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toLocaleString('en-IN');
}

export function formatFullCurrency(amount) {
  if (!amount && amount !== 0) return '---';
  const num = Number(amount);
  if (isNaN(num)) return '---';
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }).format(num);
}

export function formatDate(dateStr) {
  if (!dateStr) return '---';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return dateStr;
  }
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '---';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch {
    return dateStr;
  }
}

/**
 * Indian financial year: 1 Apr–31 Mar, formatted "YY-YY" (e.g. "26-27") to
 * match the format parsed from invoice numbers (see
 * backend/app/services/excel_parser.py — financial_year = parts[3] of
 * "SERIES/SUB/NUMBER/FY"). January–March falls in the FY that started the
 * previous April.
 */
export function getCurrentFY(date = new Date()) {
  const year = date.getFullYear();
  const startYear = date.getMonth() >= 3 ? year : year - 1; // getMonth() is 0-indexed; 3 = April
  const endYear = startYear + 1;
  return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
}

export function getBiltyStatusColor(status) {
  switch (status) {
    case 'uploaded': return 'bg-green-100 text-green-800';
    case 'verified': return 'bg-blue-100 text-blue-800';
    case 'pending': return 'bg-yellow-100 text-yellow-800';
    default: return 'bg-gray-100 text-gray-800';
  }
}
